import React, { useEffect, useRef } from 'react'

function Dropbox({ text = "", data = [], getValue, transactionFilter, }) {
    const selectRef = useRef()
    // console.log('dataproject',data);
    useEffect(() => {
        if (transactionFilter) {
            if (transactionFilter.projectName === "" || transactionFilter.project === "") {
                selectRef.current.selectedIndex = "0"
            }
        }
    }, [transactionFilter])
    return (

        <>

            <div id="dropbox">
                <div className='container'>
                    <div className=''>
                        <form>
                            <div class="form-group">
                                <select  style={{
                                   
                                   background:'#fff',
                                    color:'#0c2637',
                                    height:'60px',
                                    borderRadius:'5px',
                                    padding:'5px 10px',
                                    fontSize:'16px',
                                    fontWeight:'500',
                                    border:'none',
                                    outline:'none',
                                    cursor:'pointer',
                                    backgroundColor:'#fff'
                                }}  ref={selectRef} onChange={getValue}>
                                    <option>{text}</option>
                                    {
                                        data.map((d, i) => (
                                            <option value={d.projectName}>{d.projectName}</option>
                                        ))
                                    }
                                </select>


                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Dropbox